import React from 'react'
import PropTypes from 'prop-types'

import Ilustration from 'assets/image/customer-service/Illustration.png'

const CustomerService = () => {
  return (
    <section id="customer-services" className="">
      <div className={`flex flex-col gap-y-12 m-auto left-0 right-0  justify-between py-10 px-6 
          lg:px-14 lg:py-20 lg:gap-y-0 md:flex-row
          xl:px-[120px] xl:pt-12 xl:pb-[88px] max-w-[1440px]`}
      >
        <div className="lg:w-[440px] lg:mt-0 xl:w-[584px] xl:mt-[120px]">
          <div className="bg-[#F8FAFB] py-3 px-5 w-fit">
            <h1 className="text-[#003DA6] font-bold text-xs lg:text-sm leading-[150%]">CUSTOMER SERVICE</h1>
          </div>

          <div className="mt-6 lg:mt-[28px]">
            <h1 className="text-[#101838] font-bold text-[28px] lg:text-[40px] leading-[150%] lg:leading-[140%] whitespace-pre-line">
              {`No worries!
              We have got your back`}
            </h1>
            <p className="mt-4 lg:mt-6 leading-[150%] xl:w-[480px] text-[#969FB6]">
              Cannot find what you are looking for? Get in touch with a friendly member of our team.
            </p>
          </div>

          <a href="https://api.whatsapp.com/send?phone=6281112588989" className="flex mt-10 w-[204px] h-[54px] border border-[#003DA6] rounded-lg font-bold text-[#003DA6] justify-center items-center gap-x-2" target="_blank" rel="noreferrer">
            <WhatsAppIcon className="w-5 h-5"/> Get In Touch
          </a>
        </div>
        <div className="lg:w-[440px] lg:mt-0 xl:w-[584px] xl:mt-[0px]">
          <img src={Ilustration} alt=""/>
        </div>
      </div>
    </section>
  )
}

const WhatsAppIcon = ({ className }) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_158_103)">
        <path d="M5.28613 17.129L5.61308 17.2907C6.97558 18.0986 8.50144 18.4757 10.0274 18.4757C14.8231 18.4757 18.7468 14.5974 18.7468 9.85722C18.7468 7.59491 17.8203 5.38641 16.1855 3.77043C14.5506 2.15444 12.3707 1.23877 10.0274 1.23877C5.23168 1.23877 1.30785 5.11707 1.36238 9.91112C1.36238 11.527 1.85285 13.0892 2.67027 14.4358L2.88824 14.759L2.01636 17.9371L5.28613 17.129Z" fill="#37C99E"/>
        <path d="M17.112 2.90873C15.2591 1.02347 12.6977 0 10.0819 0C4.52328 0 0.0545312 4.47081 0.108984 9.9112C0.108984 11.6349 0.599453 13.3048 1.41695 14.813L0 19.9302L5.28617 18.5836C6.75758 19.3916 8.39242 19.7687 10.0274 19.7687C15.5316 19.7687 20.0003 15.2978 20.0003 9.85745C20.0003 7.21799 18.9648 4.74015 17.112 2.90873H17.112ZM10.0819 18.0988C8.61047 18.0988 7.13906 17.7219 5.88562 16.9677L5.55867 16.8061L2.39789 17.6141L3.21531 14.5438L2.99734 14.2205C0.599453 10.3961 1.74391 5.33266 5.66766 2.96255C9.59141 0.59251 14.6596 1.72371 17.0575 5.60201C19.4553 9.48031 18.3109 14.4898 14.3872 16.8599C13.1337 17.6679 11.6078 18.0988 10.0819 18.0988V18.0988ZM14.8776 12.1198L14.2781 11.8505C14.2781 11.8505 13.4062 11.4734 12.8612 11.2041C12.8067 11.2041 12.7523 11.1502 12.6977 11.1502C12.5342 11.1502 12.4252 11.2041 12.3162 11.258C12.3162 11.258 12.2618 11.3118 11.4988 12.1737C11.4443 12.2814 11.3353 12.3353 11.2263 12.3353H11.1718C11.1173 12.3353 11.0084 12.2814 10.9538 12.2276L10.6813 12.1198C10.0819 11.8505 9.53695 11.5273 9.10094 11.0964C8.99195 10.9886 8.82844 10.8809 8.71945 10.7732C8.33797 10.3961 7.95648 9.96517 7.68406 9.48039L7.62953 9.37266C7.57508 9.31876 7.57508 9.26494 7.52055 9.15722C7.52055 9.0495 7.52055 8.94178 7.57508 8.88788C7.57508 8.88788 7.79305 8.61853 7.95648 8.45699C8.06555 8.34919 8.12 8.18765 8.22898 8.07992C8.33797 7.9183 8.3925 7.70286 8.33797 7.54124C8.28352 7.27189 7.62953 5.81753 7.46609 5.49436C7.35703 5.33274 7.24813 5.27892 7.08461 5.22502H6.48516C6.37609 5.22502 6.26719 5.27892 6.15812 5.27892L6.10359 5.33274C5.99461 5.38664 5.88563 5.49436 5.77664 5.54819C5.66766 5.65598 5.61313 5.76363 5.50414 5.87143C5.12266 6.35622 4.90469 6.94873 4.90469 7.54124C4.90469 7.97212 5.01367 8.40309 5.17719 8.78016L5.23172 8.94178C5.72219 9.96517 6.37609 10.8809 7.24813 11.6889L7.46609 11.9043C7.62953 12.0659 7.79305 12.1737 7.90203 12.3352C9.04648 13.3049 10.3544 14.0051 11.8258 14.3822C11.9893 14.436 12.2073 14.436 12.3708 14.4899H12.9157C13.1882 14.4899 13.5152 14.3822 13.7332 14.2744C13.8966 14.1667 14.0056 14.1667 14.1146 14.059L14.2237 13.9512C14.3327 13.8435 14.4416 13.7897 14.5506 13.6819C14.6596 13.5742 14.7686 13.4665 14.8231 13.3587C14.9321 13.1432 14.9866 12.8739 15.0411 12.6046V12.2276C15.0411 12.2276 14.9866 12.1737 14.8776 12.1198Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_158_103">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

WhatsAppIcon.propTypes = {
  className: PropTypes.string
}

export default CustomerService
